import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.invoices.title',
    defaultMessage: 'Invoices',
    description: 'title of the invoices page',
  },
  create: {
    button: {
      id: 'pages.invoices.create.button',
      defaultMessage: 'New invoice',
      description: 'Label of the create button on the invoices page',
    },
  },
  previewActions: {
    changePaymentStatus: {
      label: {
        id: 'pages.invoices.previewActions.changePaymentStatus.label',
        defaultMessage: 'Change payment status',
        description: 'Label of the change payment status action in the invoice preview',
      },
    },
    view: {
      label: {
        id: 'pages.invoices.previewActions.view.label',
        defaultMessage: 'View',
        description: 'Label of the view action in the invoice preview',
      },
    },
  },
};

export default defineMessages(translations);
